import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState, useEffect } from 'react';
import { renderConfetti } from './shared';

/**
 * Custom hook to animate confetti on a canvas element
 */
var useConfettiAnimation = function useConfettiAnimation(onAnimationStart) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      renderCanvas = _useState2[0],
      setRenderCanvas = _useState2[1];

  var canvasRef = useRef(null);

  var onAnimationEnd = function onAnimationEnd() {
    setRenderCanvas(false); // remove canvas element from DOM after confetti animation has ended
  };

  useEffect(function () {
    renderConfetti({
      canvasRef: canvasRef,
      onAnimationStart: onAnimationStart,
      onAnimationEnd: onAnimationEnd
    });
  }, []);
  return {
    renderCanvas: renderCanvas,
    canvasRef: canvasRef
  };
};

export default useConfettiAnimation;